import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  loginAPIuri: string = 'login';
  registerAPIuri: string = 'register';
  forgetPasswordAPIuri: string = 'forgot-password';
  getProfileAPIuri: string = 'get-profile';
  countriesAPIuri: string = 'event/countries'

  constructor(private http: HttpClient) { }

  login(loginForm: FormGroup) {
    return this.http.post(environment.apiURI + this.loginAPIuri,
      {
        'email': loginForm.value.emailLogin,
        'password': loginForm.value.passwordLogin
      }
    ).toPromise();
  }

  register(registerForm: FormGroup) {
    return this.http.post(environment.apiURI + this.registerAPIuri,
      {
        'first_name': registerForm.value.firstnameRegister,
        'last_name': registerForm.value.lastnameRegister,
        'email': registerForm.value.emailRegister,
        'password': registerForm.value.passwordRegister,
        'confirm_password': registerForm.value.confirmpasswordRegister
      }
    ).toPromise();
  }

  forgetPassword(forgetPassword: FormGroup) {
    return this.http.post(environment.apiURI + this.forgetPasswordAPIuri,
      {
        "email": forgetPassword.value.emailForgotPassword
      }
    ).toPromise();
  }

  redirectCall(token) {
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.http.post(environment.apiURI + this.getProfileAPIuri,
      {
        "token": token
      },
      {
        headers: headers_object
      }
    ).toPromise();
  }

  getIpAddress() {
    return this.http
      .get(environment.ipifyURI)
      .toPromise();
  }

  getGEOLocation(ip) {
    // Update your api key to get from https://ipgeolocation.io
    let url = environment.ipgeolocationURI + "apiKey=" + environment.ipgeolocationKEY + "&ip=" + ip;
    return this.http
      .get(url)
      .toPromise();
  }

  getCountries() {
    return this.http.get(environment.apiURI + this.countriesAPIuri).toPromise();
  }


}
